import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface PageStore {
  title: string;
  setTitle: (value: string) => void;
  homeScroll: number;
  setHomeScroll: (value: number) => void;
}

export const usePageStore = create(
  persist<PageStore>(
    (set) => ({
      title: "",
      setTitle: (value) =>
        set({
          title: value,
        }),
      homeScroll: 1,
      setHomeScroll: (value) =>
        set({
          homeScroll: value,
        }),
    }),
    {
      name: "page-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
